import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm, UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { IWizardForm, TWizardStepId } from '../../../interfaces';

@Component({
    template: '',
    standalone: false,
})
export abstract class WizardStepBaseComponent {
    public abstract id: TWizardStepId;
    public abstract nextButtonLabel: string;

    protected get formControl(): UntypedFormGroup {
        return this.stepForm?.form;
    }

    public visible: boolean;
    public nextPageLink: string = null;

    @Input()
    public form: IWizardForm;

    @Output()
    public stepSubmit: EventEmitter<void> = new EventEmitter();

    @ViewChild('stepForm')
    public stepForm: NgForm;

    public validateAndSubmitForm(): Observable<boolean> {
        return this.formControl
            ? this.validateFormPage().pipe(switchMap((isValid) => (isValid ? this.submitWizardStep() : of(false))))
            : this.submitWizardStep();
    }

    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }

    protected abstract submitWizardStep(): Observable<boolean>;

    private validateFormPage(): Observable<boolean> {
        const formControl = this.formControl;

        formControl.updateValueAndValidity();
        formControl.markAllAsTouched();

        return of(!formControl.invalid);
    }
}
